import { render, staticRenderFns } from "./query-result-wrapper.vue?vue&type=template&id=0f938ad8"
import script from "./query-result-wrapper.vue?vue&type=script&lang=js"
export * from "./query-result-wrapper.vue?vue&type=script&lang=js"
import style0 from "./query-result-wrapper.vue?vue&type=style&index=0&id=0f938ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports